import React from 'react';
import { ShowIf } from 'components/utils';
import { Link } from 'react-router';

export default class DataTableAttachElement extends React.Component {

  addItem() {
    this.props.addItem()
  }

  render() {
    let pageNumber = this.props.pageData ? this.props.pageData.number : 0;
    let pageSize = this.props.pageData ? this.props.pageData.size : 0;

    let dataListItem = this.props.dataList.map((item, i) => {
      return (
      React.cloneElement(this.props.children, {
        key: i,
        count: (pageNumber * pageSize) + i + 1,
        item
      }))
    });

    let ItemLoading = (
    <div className="loading-content">
      <span className="shape1"></span>
      <span className="shape2"></span>
      <span className="shape3"></span>
      <span className="shape4"></span>
      <span className="shape5"></span>
      <span className="shape6"></span>
      <span className="shape7"></span>
      <span className="shape8"></span>
      <span className="shape9"></span>
      <span className="shape10"></span>
      <span className="shape11"></span>
      <span className="shape12"></span>
      <span className="shape13"></span>
    </div>
    )
    return (
      <div className='wrapper-table'>
        <div className="table-container">
          <table className="table-content">
            <thead className="table-header">
              <tr>
                { this.props.header.map((item, i) => {
                    return (
                      <th key={ i } className={ "table-header-col " + (item.className ? item.className : '') } colSpan={ item.colSpan } style={ { width: item.width, minWidth: item.minWidth } }>
                        { item.name }
                      </th>
                      );
                  }) }
              </tr>
            </thead>
            { this.props.tableLoading ? (
              <tbody className="table-body">
                <tr className="table-loading">
                  <td colSpan={ this.props.header.length }>
                    { ItemLoading }
                    { ItemLoading }
                    { ItemLoading }
                  </td>
                </tr>
              </tbody>
              ) : (
              <tbody className="table-body">
                { dataListItem }
                <tr>
                  <td className="multipe-column" colSpan={this.props.header.length}>
                    <ShowIf condition={this.props.dataList.length == 0}>
                      <span className="attach-file-description">{this.props.descriptions}</span>
                    </ShowIf>
                    <Link className="btn-addfile itt-Them-Moi" onClick={this.addItem.bind(this)}>
                      Thêm mới
                    </Link>
                  </td>
                </tr>
              </tbody>
              ) }
          </table>
        </div>
      </div>
      );
  }
}
DataTableAttachElement.defaultProps = {
  type: 'THUONG_XUYEN',
  labelPagination: 'Số hồ sơ',
  showAddMore: false,
  typeExport: 'TIEP_CONG_DAN',
  ThongKeBaoCao: false,
  header: [],
  descriptions: 'Chưa có thành viên đoàn.'
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/DataTableAttachElement.jsx